import { Info } from 'lucide-react'
import { Tooltip as TooltipPrimitive, TooltipTrigger, TooltipContent } from './tooltip-primitive'

interface TooltipProps {
  tooltipContent: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
}

export const Tooltip = ({ tooltipContent, side = "right", align = "center" }: TooltipProps) => (
  <TooltipPrimitive>
    <TooltipTrigger asChild>
      <Info className="w-4 h-4 text-gray-400 hover:text-white" />
    </TooltipTrigger>
    <TooltipContent className="bg-gray-600 text-xs text-white"
      side={side}
      align={align}
      hidden={false}
    >
      {tooltipContent}
    </TooltipContent>
  </TooltipPrimitive>
)